/* GB dynamic add-on pricing core. Pure, dependency-free, CommonJS/UMD compatible. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.GBAddonPricingCore = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var BASE_TYPES = {
    'pistol': true, 'revolver': true, 'shotgun': true, 'rifle': true,
    'smg': true, 'sniper': true, 'gel blaster': true,
    'transforming blaster': true, 'brick blaster': true
  };
  var BLANK_TYPE_HANDLES = {
    miniblaster: true,
    'stinger-miniblaster': true,
    'nano-miniblaster-fidget-toy': true
  };
  var BUNDLES = {
    'outlaw-1873-duelist-set': 2,
    'outlaw-1873-gunslinger-kit': 1,
    'cyclone-loadout': 1
  };
  var SERVICE_HANDLES = {
    giftwrap: true,
    'shipping-protection': true,
    'blaster-club-membership': true
  };

  function str(v) { return v == null ? '' : String(v); }
  function lower(v) { return str(v).toLowerCase(); }
  function id(v) { return str(v && typeof v === 'object' && v.id != null ? v.id : v); }
  function arr(v) { return Array.isArray(v) ? v : []; }
  function finite(v) { return typeof v === 'number' && Number.isFinite(v); }
  function round(v) { return Math.round(Number(v)); }

  function positiveRate(rate) {
    var n = typeof rate === 'number' ? rate : Number(rate);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  function amountToCents(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'object') {
      if (value.cents != null) return amountToCents(value.cents);
      if (value.amount != null) return round(Number(value.amount) * 100);
      if (value.value != null) return amountToCents(value.value);
    }
    var n = Number(value);
    return Number.isFinite(n) ? round(n) : null;
  }

  function allocationCents(allocation) {
    if (!allocation) return 0;
    return amountToCents(allocation.allocatedAmountSet || allocation.allocated_amount_set || allocation.amount || allocation.allocatedAmount || allocation) || 0;
  }

  function netLineCents(line) {
    var direct = ['netCents', 'effectiveNetCents', 'effective_net_cents'];
    for (var i = 0; i < direct.length; i += 1) {
      if (line[direct[i]] != null) return amountToCents(line[direct[i]]) || 0;
    }
    var original = amountToCents(line.originalLinePrice != null ? line.originalLinePrice : line.original_line_price);
    var allocations = arr(line.discountAllocations || line.discount_allocations);
    if (original != null) return Math.max(0, original - allocations.reduce(function (sum, item) { return sum + allocationCents(item); }, 0));
    var direct = ['finalLinePrice', 'final_line_price', 'discountedTotalCents', 'discounted_total_cents'];
    for (var i = 0; i < direct.length; i += 1) {
      if (line[direct[i]] != null) return amountToCents(line[direct[i]]) || 0;
    }
    var discounted = line.discountedTotalSet || line.discounted_total_set || line.discountedTotal;
    return amountToCents(discounted) || 0;
  }

  function tags(line) { return arr(line.productTags || line.tags || line.product_tags).map(lower); }
  function collections(line) { return arr(line.collections || line.collectionHandles || line.collection_handles).map(lower); }
  function handle(line) { return lower(line.handle || line.productHandle || line.product_handle || (line.product && line.product.handle)); }
  function productType(line) { return lower(line.productType || line.product_type || (line.product && line.product.productType)); }
  function title(line) { return lower(line.title || line.name || (line.product && line.product.title)); }

  function isServiceLine(line) {
    var h = handle(line), t = title(line), pt = productType(line), ts = tags(line);
    if (SERVICE_HANDLES[h]) return true;
    if (pt === 'membership' || pt === 'service' || pt.indexOf('membership') >= 0) return true;
    if (t === 'tip' || t.indexOf('tip ') === 0) return true;
    return false;
  }

  function isDigitalLine(line) {
    var pt = productType(line), ts = tags(line), t = title(line);
    return Boolean(line.isGiftCard || line.is_gift_card) || pt === 'digital' || pt.indexOf('free gift (digital)') >= 0 ||
      ts.indexOf('digital-gift') >= 0 || ts.indexOf('free-gift') >= 0 || ts.indexOf('hidden-gift') >= 0 ||
      t.indexOf('ebook') >= 0 || t.indexOf('e-book') >= 0;
  }

  function isPhysicalMerchandise(line) {
    if (isServiceLine(line) || isDigitalLine(line)) return false;
    if (line.requiresShipping === false && !isBaseBlaster(line)) return false;
    return true;
  }

  function isBaseBlaster(line) {
    var h = handle(line), pt = productType(line), cs = collections(line);
    if (BUNDLES[h]) return true;
    if (cs.indexOf('shell-blasters') >= 0 || cs.indexOf('brick-blasters') >= 0) return true;
    if (BASE_TYPES[pt]) return true;
    if (!pt && BLANK_TYPE_HANDLES[h]) return true;
    return false;
  }

  function componentIds(lines) {
    var ids = {};
    arr(lines).forEach(function (line) {
      arr(line.lineComponents || line.line_components || line.components).forEach(function (component) {
        var cid = id(component.id || component.lineId || component.line_id || component);
        if (cid) ids[cid] = true;
      });
    });
    return ids;
  }

  function countBlasterUnits(lines) {
    var children = componentIds(lines);
    return arr(lines).reduce(function (sum, line) {
      if (children[id(line.id)] && !line.isBundleParent && !line.is_bundle_parent) return sum;
      if (!isBaseBlaster(line)) return sum;
      var qty = Number(line.quantity == null ? 0 : line.quantity) || 0;
      return sum + qty * (BUNDLES[handle(line)] || 1);
    }, 0);
  }

  function merchandiseSubtotalCents(lines) {
    var children = componentIds(lines);
    return arr(lines).reduce(function (sum, line) {
      if (children[id(line.id)] && !line.isBundleParent && !line.is_bundle_parent) return sum;
      return sum + (isPhysicalMerchandise(line) ? netLineCents(line) : 0);
    }, 0);
  }

  function selectedAddonCents(lines, productIds, expectedHandle) {
    var ids = arr(productIds).map(id), target = lower(expectedHandle);
    for (var i = 0; i < arr(lines).length; i += 1) {
      var line = lines[i], productId = id(line.productId || line.product_id), variantId = id(line.variantId || line.variant_id);
      if (Number(line.quantity || 0) > 0 && (ids.indexOf(productId) >= 0 || ids.indexOf(variantId) >= 0 || handle(line) === target)) return netLineCents(line);
    }
    return null;
  }

  function displayCents(row, rate) {
    if (row && row.displayCents != null) return amountToCents(row.displayCents);
    return null;
  }

  function quoteGiftwrap(units, mapping, rate) {
    var r = positiveRate(rate), n = Number(units) || 0;
    if (!n) return { status: 'none', units: 0, variantId: null, amountCents: 0, usdCents: 0 };
    if (r == null) return { status: 'rate-unavailable', units: n, variantId: null, amountCents: null, usdCents: null };
    var tier = n >= 4 ? 4 : n;
    var row = mapping && mapping.tiers && mapping.tiers[tier];
    if (!row || !row.variantId) return { status: 'variant-unavailable', units: n, variantId: null, amountCents: null, usdCents: row ? row.usdCents : null };
    var amount = displayCents(row, r);
    if (amount == null) return { status: 'rate-unavailable', units: n, tier: tier, variantId: null, amountCents: null, usdCents: Number(row.usdCents) };
    return { status: 'ready', units: n, tier: tier, variantId: id(row.variantId), usdCents: Number(row.usdCents), amountCents: amount };
  }

  function quoteProtection(lines, mapping, rate) {
    var merch = merchandiseSubtotalCents(lines), r = positiveRate(rate);
    if (!merch) return { status: 'no-merchandise', merchandiseCents: 0, variantId: null, amountCents: 0, usdCents: 0 };
    if (r == null) return { status: 'rate-unavailable', merchandiseCents: merch, variantId: null, amountCents: null, usdCents: null };
    var usdMerch = round(merch / r), key = usdMerch < 6000 ? 'under60' : usdMerch < 10000 ? 'under100' : usdMerch < 15000 ? 'under150' : usdMerch < 25000 ? 'under250' : 'over250';
    var row = mapping && mapping.tiers && mapping.tiers[key];
    if (!row || !row.variantId) return { status: 'variant-unavailable', merchandiseCents: merch, usdMerchandiseCents: usdMerch, tier: key, variantId: null, amountCents: null, usdCents: row ? row.usdCents : null };
    var amount = displayCents(row, r);
    if (amount == null) return { status: 'rate-unavailable', merchandiseCents: merch, usdMerchandiseCents: usdMerch, tier: key, variantId: null, amountCents: null, usdCents: Number(row.usdCents) };
    return { status: 'ready', merchandiseCents: merch, usdMerchandiseCents: usdMerch, tier: key, variantId: id(row.variantId), usdCents: Number(row.usdCents), amountCents: amount };
  }

  function reconcileAddonLines(input) {
    var lines = arr(input && input.lines), updates = {}, wrap = input && input.wrap || { status: 'none' }, protection = input && input.protection || { status: 'none' };
    var wrapIds = arr(input && input.wrapProductIds).map(id), protectionIds = arr(input && input.protectionProductIds).map(id);
    var wantWrap = !input || input.wrapChoice !== 'off';
    var wantProtection = !input || input.protectionChoice !== 'off';
    var wrapOn = wantWrap && wrap.status === 'ready';
    var protectionOn = wantProtection && protection.status === 'ready';
    var wrapUnavailable = wantWrap && !wrapOn && wrap.status !== 'none';
    var protectionUnavailable = wantProtection && !protectionOn && protection.status !== 'no-merchandise';
    var targetWrap = wrapOn ? id(wrap.variantId) : null, targetProtection = protectionOn ? id(protection.variantId) : null;
    var keptWrap = false, keptProtection = false;
    lines.forEach(function (line) {
      var lineId = id(line.key || line.id), productId = id(line.productId || line.product_id), variantId = id(line.variantId || line.variant_id), qty = Number(line.quantity || 0);
      var isWrap = wrapIds.indexOf(productId) >= 0 || wrapIds.indexOf(variantId) >= 0 || handle(line) === 'giftwrap';
      var isProtection = protectionIds.indexOf(productId) >= 0 || protectionIds.indexOf(variantId) >= 0 || handle(line) === 'shipping-protection';
      if ((isWrap || isProtection) && qty > 0 && !lineId) throw new Error('Missing service cart line key');
      var isTargetWrap = targetWrap && (variantId === targetWrap || productId === targetWrap);
      var isTargetProtection = targetProtection && (variantId === targetProtection || productId === targetProtection);
      if (isWrap) {
        if (isTargetWrap && !keptWrap && wrapOn) { keptWrap = true; if (qty !== 1) updates[lineId] = 1; }
        else if (qty > 0 && (!wrapUnavailable || !wantWrap)) updates[lineId] = 0;
      } else if (isProtection) {
        if (isTargetProtection && !keptProtection && protectionOn) { keptProtection = true; if (qty !== 1) updates[lineId] = 1; }
        else if (qty > 0 && (!protectionUnavailable || !wantProtection)) updates[lineId] = 0;
      }
    });
    if (targetWrap && wrapOn && !keptWrap) updates['variant:' + targetWrap] = 1;
    if (targetProtection && protectionOn && !keptProtection) updates['variant:' + targetProtection] = 1;
    var changed = Object.keys(updates).some(function (key) { return updates[key] !== undefined; });
    return { updates: updates, shouldWrite: changed, wrapOn: wrapOn, protectionOn: protectionOn, targetWrap: targetWrap, targetProtection: targetProtection };
  }

  function latestIntent(previous, next) { return next == null ? previous : next; }

  function createSerializedQueue(executor) {
    var pendingIntent = null, waiters = [], active = false, timer = null;
    function drain() {
      timer = null;
      if (active || !pendingIntent) return;
      var intent = pendingIntent, currentWaiters = waiters;
      pendingIntent = null; waiters = []; active = true;
      Promise.resolve().then(function () { return executor(intent); }).catch(function () { return false; }).then(function (result) {
        active = false;
        currentWaiters.forEach(function (resolve) { resolve(result); });
        if (pendingIntent && !timer) timer = setTimeout(drain, 0);
      });
    }
    return {
      enqueue: function (intent) {
        pendingIntent = Object.assign({}, pendingIntent || {}, intent || {});
        return new Promise(function (resolve) {
          waiters.push(resolve);
          if (!active && !timer) timer = setTimeout(drain, 0);
        });
      }
    };
  }

  return {
    buildId: 'gb-addon-v1-r4',
    BASE_TYPES: BASE_TYPES,
    BUNDLES: BUNDLES,
    amountToCents: amountToCents,
    netLineCents: netLineCents,
    isBaseBlaster: isBaseBlaster,
    isPhysicalMerchandise: isPhysicalMerchandise,
    countBlasterUnits: countBlasterUnits,
    merchandiseSubtotalCents: merchandiseSubtotalCents,
    selectedAddonCents: selectedAddonCents,
    quoteGiftwrap: quoteGiftwrap,
    quoteProtection: quoteProtection,
    reconcileAddonLines: reconcileAddonLines,
    latestIntent: latestIntent,
    createSerializedQueue: createSerializedQueue,
    positiveRate: positiveRate,
  };
});
